export const colors = {
  black: '#0D0B0B',
  green: '#09FCC2',
  greenDarker: '#09e4b0',
  brown: '#C29D79',
};



// WEBPACK FOOTER //
// ./src/themes/variables.js